site.news = {
	init: function () {
		var $entries = $('.entries', '#news');
		if (!$entries) return false;

		$('a', '.loadMore').on('click touchStart', function (e) {
			e.preventDefault();
			$(this).addClass('loading');

			site.news.loadNews({
				url: $entries.data('url'),
				page: $entries.data('page'),
				total: $entries.data('total'),
			});
		});
	},

	loadNews: function (options) {
		$.ajax({
			url: options.url + parseInt(options.page),
			dataType: 'json',
			success: function (r) {
				$('a', '.loadMore').removeClass('loading');
				var $entries = $('.entries', '#news');
				$entries.append(r);
				$entries.data('page', parseInt(options.page) + 1);

				if ($('.entry', $entries).length === options.total) {
					$('.loadMore').hide();
				}

				$('img.responsive:not(.loaded)').responsiveImg();
			},

			error: function (e) {
				console.log(e);
			}
		});
	}
};

site.inits.push('site.news.init()');
